import styled from "styled-components";
import React from "react";

const StyledHeroBg = styled.div`
  position: absolute;
  width: 100%;
  height: ${props => props.leftHeight}px;
  background-color: ${props => props.theme.color.base.getShade(8)};

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
    transform: skew(0, ${props => props.angleRad}rad);
    background-color: inherit;
    width: 100%;
    height: 100%;
    content: "";
  }
`;

/**
 * @param widthBasis Width of splash, as read off of design file
 * @param leftHeight Height of splash on the right side, as read off design file
 * @param rightHeight Height of splash on the left side, read from the top (colored height, not white height)
 * Left height is held constant to assist with left-based positioning and alignment (e.g. small screen explore search)
 * (Hence also the use of skew instead of background-image. Angled gradients are always center-based)
 */
export default function HeroSplash({ widthBasis, leftHeight, rightHeight }) {
  const angleRad = Math.atan((rightHeight - leftHeight) / widthBasis);
  return <StyledHeroBg angleRad={angleRad} leftHeight={leftHeight} />;
}
